<template>
  <div class="red_packet_edit">
    <div class="go_back_col">
      <!-- <i class="el-icon-arrow-left"></i> -->
      <!-- <span @click="goBack">返回</span> -->
    </div>
    <el-form
      ref="form"
      class="form_box"
      :model="form"
      :rules="rules"
      label-width="150px"
      label-position="left"
      v-loading="loading"
    >
      <el-form-item label="红包类型:">
        <el-radio v-model="redpack_type" :label="1">随机金额红包</el-radio>
        <el-radio v-model="redpack_type" :label="2">固定金额红包</el-radio>
      </el-form-item>
      <el-form-item label="红包名称:" prop="redpack_name">
        <el-input
          v-model.trim="form.redpack_name"
          placeholder="请输入"
          maxlength="32"
          show-word-limit
          clearable
        />
      </el-form-item>
      <div v-if="redpack_type == 1">
        <el-form-item label="红包数量:" prop="total_num">
          <el-input
            v-model.number="form.total_num"
            placeholder="请输入"
            :maxlength="11"
            @input="checkDataLegal($event, 'total_num', true)"
          >
            <span slot="suffix">个</span>
          </el-input>
        </el-form-item>
        <el-form-item label="红包总额:" prop="total_amount">
          <el-input
            v-model.number="form.total_amount"
            placeholder="请输入"
            :maxlength="11"
            @input="checkDataLegal($event, 'total_amount')"
            @blur="formatNumber('total_amount')"
          >
            <span slot="suffix">元</span>
          </el-input>
        </el-form-item>

        <el-form-item label="最小金额:" prop="min_amount">
          <el-input
            v-model.number="form.min_amount"
            placeholder="请输入"
            :maxlength="11"
            @input="checkDataLegal($event, 'min_amount')"
            @blur="formatNumber('min_amount')"
          >
            <span slot="suffix">元</span>
          </el-input>
        </el-form-item>
        <el-form-item label="最大金额:" prop="max_amount">
          <el-input
            v-model.number="form.max_amount"
            placeholder="请输入"
            :maxlength="11"
            @input="checkDataLegal($event, 'max_amount')"
            @blur="formatNumber('max_amount')"
          >
            <span slot="suffix">元</span>
          </el-input>
        </el-form-item>
      </div>
      <div v-else>
        <el-form-item label="单个红包金额:" prop="fixed_amount">
          <el-input
            v-model.number="form.fixed_amount"
            placeholder="请输入"
            :maxlength="11"
            @input="checkDataLegal($event, 'fixed_amount')"
            @blur="formatNumber('fixed_amount')"
          >
            <span slot="suffix">元</span>
          </el-input>
        </el-form-item>
        <el-form-item label="红包数量:" prop="total_num">
          <el-input
            v-model.number="form.total_num"
            placeholder="请输入"
            :maxlength="11"
            @input="checkDataLegal($event, 'total_num', true)"
          >
            <span slot="suffix">个</span>
          </el-input>
        </el-form-item>
        <el-form-item label="红包总额:">
          <el-input v-model="total_amount" placeholder="自动计算中…" :maxlength="11" disabled>
            <span slot="suffix">元</span>
          </el-input>
        </el-form-item>
      </div>
      <el-form-item label="祝福语:" prop="wishing">
        <el-input
          type="textarea"
          placeholder="请输入内容"
          v-model="form.wishing"
          maxlength="128"
          show-word-limit
          :autosize="{ minRows: 2 }"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          type="textarea"
          placeholder="请输入内容"
          v-model="form.remark"
          maxlength="256"
          show-word-limit
          :autosize="{ minRows: 4 }"
        ></el-input>
      </el-form-item>
      <div class="submit_btn">
        <el-button type="primary" @click="onSubmit">保存</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import {
  createRedpackInfoApi,
  updateRedpackInfoApi,
  getRedpackListApi,
} from '@/api/enterpriseWeChatManagement';
import { mapGetters } from 'vuex';
import { awaitInterfaceResponse } from '@/utils/util';
const resetForm = {
  redpack_name: null,
  total_amount: null,
  max_amount: null,
  total_num: null,
  min_amount: null,
  fixed_amount: null,
  wishing: '',
  remark: '',
};
export default {
  data() {
    const validateAmount = (rule, value, callback) => {
      if (value >= 1 && value <= 200) {
        callback();
      } else {
        callback(new Error('金额只能在1-200之间'));
      }
    };
    return {
      redpack_type: 1,
      form: {
        redpack_name: null,
        total_amount: null,
        max_amount: null,
        total_num: null,
        min_amount: null,
        fixed_amount: null,
        wishing: '',
        remark: '',
      },
      rules: {
        redpack_name: [{ required: true, message: '请输入', trigger: 'blur' }],
        num: [{ required: true, message: '请输入', trigger: 'blur' }],
        total_amount: [{ required: true, message: '请输入', trigger: 'blur' }],
        min_amount: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: validateAmount, trigger: 'blur' },
        ],
        max_amount: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: validateAmount, trigger: 'blur' },
        ],
        total_num: [{ required: true, message: '请输入', trigger: 'blur' }],
        fixed_amount: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: validateAmount, trigger: 'blur' },
        ],
        wishing: [{ required: true, message: '请输入', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      bottonLoading: false,
      id: this.$route.query.id,
      loading: false,
    };
  },
  computed: {
    total_amount() {
      // const totalAmount = this.form.fixed_amount * this.form.total_num;
      if (this.form.fixed_amount === null || this.form.total_num === null) {
        return '自动计算中…';
      }
      return this.form.fixed_amount * this.form.total_num;
    },
    isEdit() {
      return this.id !== null && this.id !== undefined && this.id !== '';
    },
    ...mapGetters('user', {
      userid: 'getUserId',
    }),
  },
  watch: {
    redpack_type: {
      handler() {
        this.form = Object.assign({}, resetForm);
      },
    },
  },
  created() {},
  mounted() {
    const breadcrumb = [
      { menu_name: '企业微信管理', menu_path: '' },
      { menu_name: '企业红包', menu_path: 'enterpriseRedPacket' },
    ];
    let menuName = '新增企业红包';
    if (this.isEdit) {
      menuName = '编辑企业红包';
      this.loading = true;
      // 等待拿到userId 后再调取详情接口
      awaitInterfaceResponse('userid', this)
        .then(() => {
          this.getRedpackDetails();
        })
        .catch(() => {
          this.loading = false;
          this.$message.error('无法找到userId');
        });
    }
    breadcrumb.push({ menu_name: menuName });
    this.g_breadcrumb(breadcrumb);
  },
  methods: {
    goBack() {
      this.$emit('changeComponet', 'redPacketList');
    },
    // 检测数据是否是数字并且保留两位小数点
    checkDataLegal(num, key, integer) {
      if (num && !isNaN(Number(num))) {
        let result = null;
        if (integer) {
          result = Number(num.replace(/[^\d]/g, ''));
        } else {
          result = num.replace(/([0-9]+\.[0-9]{2})[0-9]*/, '$1');
        }
        this.form[key] = result;
      } else {
        this.form[key] = null;
      }
    },
    // 失去焦点 把值变成数字类型
    formatNumber(key) {
      this.form[key] = Number(this.form[key]);
    },
    // 新增红包
    createRedpackInfo(form) {
      createRedpackInfoApi(form)
        .then((res) => {
          if (res.err_code) {
            this.$message.error(res.err_msg);
            this.loading = false;
            return;
          }
          this.$message.success('新增成功');
          this.loading = false;
          setTimeout(() => {
            this.$emit('changeComponet', 'redPacketList');
          }, 2000);
        })
        .catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
    },
    // 更新红包
    updateRedpackInfo(form) {
      updateRedpackInfoApi(form)
        .then((res) => {
          if (res.err_code) {
            this.$message.error(res.err_msg);
            this.loading = false;
            return;
          }
          this.$message.success('编辑成功');
          this.loading = false;
          setTimeout(() => {
            this.$emit('changeComponet', 'redPacketList');
          }, 2000);
        })
        .catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
    },
    // 获取红包详情
    getRedpackDetails() {
      getRedpackListApi({
        user_id: String(this.userid),
        redpack_id: Number(this.id),
      })
        .then((res) => {
          const info = res.info[0];
          if (info) {
            this.redpack_type = info.redpack_type;
            this.$nextTick(() => {
              // 金额单位除以100
              info && info.fixed_amount ? (info.fixed_amount /= 100) : '';
              info && info.total_amount ? (info.total_amount /= 100) : '';
              info && info.min_amount ? (info.min_amount /= 100) : '';
              info && info.max_amount ? (info.max_amount /= 100) : '';
              //   revd_amount
              //   unrevd_amount

              this.form = info || {};
              this.loading = false;
            });
          }
        })
        .catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
    },
    // 提交
    onSubmit() {
      this.$refs.form.validate((v) => {
        if (v) {
          const info = {
            total_num: this.form.total_num,
            total_amount: this.form.total_amount,
          };
          if (info.total_num === 0) {
            this.$message.error('红包数量应大于0');
            return;
          }
          if (this.redpack_type == 1) {
            info.max_amount = this.form.max_amount;
            info.min_amount = this.form.min_amount;

            if (info.min_amount > info.max_amount) {
              this.$message.error('最小金额必须 小于等于 最大金额');
              return;
            }
            if (info.min_amount * info.total_num > info.total_amount) {
              this.$message.error('最小金额 * 红包数 需要小于或等于 红包总金额');
              return;
            }
            if (info.total_amount > info.max_amount * info.total_num) {
              this.$message.error('红包总金额 需要小于或等于 最大金额 * 红包数');
              return;
            }
          } else {
            info.fixed_amount = this.form.fixed_amount;
            info.total_amount = this.total_amount;
          }
          // 插入数据
          info.redpack_name = this.form.redpack_name;
          info.redpack_type = this.redpack_type;
          info.remark = this.form.remark;
          info.wishing = this.form.wishing;
          const form = {
            user_id: String(this.userid),
            info,
          };
          this.loading = true;

          // 金额单位乘100
          //   info.fixed_amount *= 100;
          //   info.total_amount *= 100;
          //   info.min_amount *= 100;
          //   info.max_amount *= 100;

          if (this.isEdit) {
            form.id = Number(this.id);
            this.updateRedpackInfo(form);
          } else {
            this.createRedpackInfo(form);
          }
        } else {
          this.$message.error('请正确的填写表单');
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
